function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations, mapState } from 'vuex';
import MonitoringAccessService from '@/apps/data-platform/services/reports/monitoring_access';
import tasks from '@/js/tasks';
export default {
  name: 'MonitoringReports',
  components: {},
  props: {
    flag_settings: {
      type: Boolean,
      default: false
    },
    settings_param: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      isLoading: false,
      keyDashboardsList: 0,
      items: [],
      headers: [{
        value: 'title',
        text: 'Nombre'
      }, {
        value: 'description',
        text: 'Descripcion'
      }, {
        value: 'actions',
        text: ''
      }],
      valid: true,
      settings: {
        title: '',
        subTitle: '',
        roles_allowed: []
      }
    };
  },
  created: function created() {
    if (this.flag_settings) {
      this.settings = this.settings_param;
    }
    this.getInfo();
  },
  computed: _objectSpread(_objectSpread({}, mapState('data-platform', ['companyCode', 'companyName'])), {}, {
    getClass: function getClass() {
      if (this.filterEnabled) {
        return 'col-md-9 col-12 order-md-first order-last';
      } else {
        return 'col-12 order-md-first order-last';
      }
    },
    title: function title() {
      return this.settings.title || this.$t('monitoring_billing.title_reports');
    },
    subTitle: function subTitle() {
      return this.settings.subTitle || this.$t('monitoring_billing.reports_desc');
    }
  }),
  methods: _objectSpread(_objectSpread({}, mapMutations('app', ['setShowLoading'])), {}, {
    onClose: function onClose() {},
    onVer: function onVer(item) {
      this.$router.push({
        name: 'MonitoringReportsView',
        query: {
          v: item.document_id,
          m: item['multiorg'] ? item['multiorg'] : false
        }
      });
    },
    getInfo: function getInfo() {
      var _this = this;
      this.setShowLoading(true);
      var data = {
        'is_setting': false
      };
      MonitoringAccessService.getBillingMonitoring(data).then(function (response) {
        var response_data = response.data;
        var pre_items = [];
        response_data.forEach(function (item) {
          if (Array.isArray(item.roles) && item.roles.some(function (role) {
            return window.userInfo.userRoles.includes(role);
          })) {
            if (_this.flag_settings) {
              if (item.roles.some(function (role) {
                return window.userInfo.userRoles.includes(role);
              })) {
                pre_items.push(item);
              }
            } else {
              pre_items.push(item);
            }
          }
        });
        _this.items = pre_items;
        _this.key_items += 1;
        _this.setShowLoading(false);
      }).catch(function (error) {
        tasks.toast.error('Error: ' + error.message);
        _this.setShowLoading(false);
      });
    },
    openReport: function openReport(item) {}
  })
};